import React from 'react';
import { Button } from '@mui/material';

interface EditGstActionsProps {
  onSaveGst: (companyName: string) => void;
  onCancelEditGst: (companyName: string) => void;
  companyName: string;
}

const EditGstActions: React.FC<EditGstActionsProps> = ({
  onSaveGst,
  onCancelEditGst,
  companyName,
}) => {
  return (
    <>
      <Button
        variant="outlined"
        onClick={() => onSaveGst(companyName)}
        size="small">
        Save
      </Button>
      <Button
        variant="outlined"
        onClick={() => onCancelEditGst(companyName)}
        size="small">
        Cancel
      </Button>
    </>
  );
};

export default EditGstActions;
